import type React from 'react';
import { Paragraph, Tooltip, TooltipPopper, TriggerText } from '@zillow/constellation';

type Props = {
  tooltipBodyText: string | React.ReactNode;
  children: string | React.ReactNode;
  closeWith?: Array<string>;
  openWith?: Array<string>;
  shouldCloseOnOutsideClick?: boolean;
};

InlineTooltip.defaultProps = {
  closeWith: ['blur'],
  openWith: ['focus', 'click', 'mouseEnter'],
  shouldCloseOnOutsideClick: true,
};

export default function InlineTooltip({ tooltipBodyText, children, closeWith, openWith }: Props): JSX.Element {
  const tooltip = <Tooltip shouldCloseOnOutsideClick body={<Paragraph>{tooltipBodyText}</Paragraph>} />;

  return (
    <TooltipPopper triggered={tooltip} closeWith={closeWith} openWith={openWith}>
      <TriggerText as="a" role="button">
        {children}
      </TriggerText>
    </TooltipPopper>
  );
}
